import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let PaginatorComponent = class extends Mixins(MagicConfigMixin) {
  get links() {
    const prevPage = Math.max(this.currentPage - 1, 1);
    const nextPage = Math.min(this.currentPage + 1, this.totalPages);
    return [
      { icon: false, page: 1 },
      { icon: "left-arrow", page: prevPage },
      { icon: false, page: this.currentPage },
      { icon: "right-arrow", page: nextPage },
      { icon: false, page: this.totalPages }
    ].map(({ icon, page }) => {
      return {
        icon,
        page,
        isEnabled: this.currentPage !== page,
        isCurrent: this.currentPage === page,
        link: this.getPageLink(page)
      };
    });
  }
  getPageLink(page) {
    var _a, _b;
    if (this.link) {
      return __spreadProps(__spreadValues({}, (_a = this.link) != null ? _a : {}), {
        params: __spreadProps(__spreadValues({}, (_b = this.link.params) != null ? _b : {}), {
          page
        })
      });
    }
    return null;
  }
  setPage(page, event) {
    if (!this.link && event) {
      event.preventDefault();
    }
    return page;
  }
};
__decorateClass([
  Prop(Number)
], PaginatorComponent.prototype, "currentPage", 2);
__decorateClass([
  Prop(Number)
], PaginatorComponent.prototype, "totalPages", 2);
__decorateClass([
  Prop({
    type: Object,
    required: false
  })
], PaginatorComponent.prototype, "link", 2);
__decorateClass([
  Emit("set-page")
], PaginatorComponent.prototype, "setPage", 1);
PaginatorComponent = __decorateClass([
  Component({
    name: "ui-paginator"
  })
], PaginatorComponent);

export default PaginatorComponent;
